import { useTranslation } from "react-i18next";

import { localizedHref, resolveLang } from "../lib/links";

const NAV_ITEMS = [
  { id: "ecosystem", labelKey: "header.nav.features" },
  { id: "process", labelKey: "header.nav.process" },
  { id: "knowledge", labelKey: "header.nav.knowledge" },
  { id: "faq", labelKey: "header.nav.faq" },
] as const;

const LEGAL_ITEMS = [
  { path: "/terms", labelKey: "footer.legal.terms" },
  { path: "/privacy", labelKey: "footer.legal.privacy" },
  { path: "/medical-disclaimer", labelKey: "footer.legal.medicalDisclaimer" },
] as const;

export function Footer() {
  const { t, i18n } = useTranslation("landing");
  const lang = resolveLang(i18n.resolvedLanguage);

  return (
    <footer
      className="border-t border-border bg-background py-10"
      role="contentinfo"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-4 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <div>
          <p className="font-semibold text-foreground">{t("footer.brand")}</p>
          <p className="mt-1 text-sm text-muted-foreground">{t("footer.tagline")}</p>
        </div>
        <nav
          className="flex flex-wrap gap-4 text-sm text-muted-foreground"
          aria-label={t("footer.navAriaLabel", "Footer navigation")}
        >
          {NAV_ITEMS.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="inline-flex min-h-[44px] min-w-[44px] items-center transition-colors hover:text-foreground"
            >
              {t(item.labelKey)}
            </a>
          ))}
          <a
            href={localizedHref("/login", lang)}
            className="inline-flex min-h-[44px] min-w-[44px] items-center transition-colors hover:text-foreground"
          >
            {t("footer.signIn")}
          </a>
          {LEGAL_ITEMS.map((item) => (
            <a
              key={item.path}
              href={localizedHref(item.path, lang)}
              className="inline-flex min-h-[44px] min-w-[44px] items-center transition-colors hover:text-foreground"
            >
              {t(item.labelKey)}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
}

export const LandingFooter = Footer;
export default Footer;
